/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useLayoutEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { bool, func, number, arrayOf, shape } from "prop-types";
import { Link } from "react-router-dom";
import { selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";
import ProductList from "pages/_components/product/List";
import GridTable from "pages/_components/GridTable/GridTable";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import CustomData from "pages/_components/CustomData/CustomData";
import VepsHistoricItem from "./components/ItemRow";
import TitleColumns from "./components/TitleColums";
import FilterForm from "../components/FilterForm";

const VepsHistoric = ({ isDesktop, fetching, positionTab, vepsList, vepsFilters, hasMoreData }) => {
    const dispatch = useDispatch();
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        dispatch(afipPaymentLinkActions.cleanVepFilters());
        dispatch(afipPaymentLinkActions.cleanVepsList());
    }, []);

    const handleFetchData = (filters) => {
        dispatch(afipPaymentLinkActions.cleanVepsList());
        dispatch(afipPaymentLinkActions.setVepFilters(filters));
        dispatch(afipPaymentLinkActions.listVepsHistoric(filters));
    };

    const fetchMoreTransactions = () => {
        const newPage = pageNumber + 1;
        const newFilters = { ...vepsFilters, pageNumber: newPage };
        dispatch(afipPaymentLinkActions.setVepFilters(newFilters));
        dispatch(afipPaymentLinkActions.listVepsHistoric(newFilters));
        setPageNumber(newPage);
    };

    return (
        <div className="container py-8">
            <FilterForm isVepInProgress onSubmit={handleFetchData} loading={fetching} />
            <div className="pb-6" />
            {vepsFilters && vepsList.length > 0 ? (
                <ProductList
                    onLoadMoreClick={() => {}}
                    fetchingWithPreviousData
                    fetching={fetching}
                    items={vepsList}
                    noDataText="vep.historic.list.empty"
                    noFiltersDataText="global.no.results"
                    renderItem={(item) => (
                        <GridTable.Container
                            key={`vep-historic-item-${item.id}`}
                            renderAs="div"
                            className={!isDesktop && "box box-shadow"}>
                            <VepsHistoricItem
                                vep={item}
                                // setActionDrawer={() => {}}
                                isDesktop={isDesktop}
                                positionTab={positionTab}
                                type={vepsFilters?.queryType}
                            />
                        </GridTable.Container>
                    )}>
                    {(listItem) => (
                        <GridTable className="vep-historic-table tablelist received">
                            {isDesktop && (
                                <GridTable.Header>
                                    <GridTable.Container>
                                        <TitleColumns />{" "}
                                    </GridTable.Container>
                                </GridTable.Header>
                            )}
                            <GridTable.Body>{listItem}</GridTable.Body>
                            {hasMoreData && (
                                <Button
                                    bsStyle="link"
                                    onClick={() => fetchMoreTransactions()}
                                    image="images/figma/icon/arrow.svg"
                                    label="global.showMore"
                                    className="view-more"
                                />
                            )}
                        </GridTable>
                    )}
                </ProductList>
            ) : (
                vepsFilters && (
                    <div className="box info">
                        <CustomData
                            icon="information_fill.svg"
                            titleText="vep.historic.list.empty"
                            titleTextType="I18N"
                        />
                    </div>
                )
            )}
        </div>
    );
};

VepsHistoric.propTypes = {
    isDesktop: bool.isRequired,
    fetching: bool.isRequired,
    positionTab: number.isRequired,
    vepsList: arrayOf(shape({})).isRequired,
    vepsFilters: arrayOf(shape({})).isRequired,
    hasMoreData: bool.isRequired,
};

const mapStateToProps = (state) => ({
    fetching: afipPaymentLinkSelectors.getFetching(state),
    vepsList: afipPaymentLinkSelectors.getVeps(state),
    vepsFilters: afipPaymentLinkSelectors.getFilters(state),
    hasMoreData: afipPaymentLinkSelectors.getHasMoreData(state),
});

export default connect(mapStateToProps)(VepsHistoric);
